// extracted by mini-css-extract-plugin
export default {"count":"ResultsCount_count__LGsFt"};